/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';

import { Emoji } from 'Shared/components/EmojiMartComponents';

function EmojiEntryComponent({ mention, theme, isFocused, searchValue, ...parentProps }) {
  return (
    <div {...parentProps} className={`${parentProps.className} py-2`}>
      <span className={`${theme.mentionSuggestionsEntryText} m-0 d-block`} style={{ lineHeight: 0 }}>
        <Emoji emoji={mention} size={22} />
        <span className="ml-2 mb-2" style={{ verticalAlign: 'super', fontSize: '15px' }}>
          {mention.colons}
        </span>
      </span>
    </div>
  );
}

export default EmojiEntryComponent;
